import {remote} from '../constants/environment';
import {ISignup} from '../interfaces/dtos';
import {ISignupResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postSignUp = async (signup: ISignup): Promise<ISignupResponse> => {
  const remoteURI = remote.getSignUpUri();

  const {company, rif, entity, firstname, lastname, email} = signup;
  const payload: ISignup = {
    company,
    rif,
    entity,
    firstname,
    lastname,
    email,
  };

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify({
          payload,
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          return {
            success: true,
            payload: {},
          };
        } else {
          return {
            success: false,
            payload: {
              credentials: null,
            },
          };
        }
      }
    },
    remoteURI,
  )) as any;
};
